module.exports = __webpack_public_path__ + "static/img_4782-b5f1ab5f75e11d23772ebd4963b48c88.webp";